import { useContext } from "react"
import { UserContext } from "../Context/UserContext"
import ColorLabels from "./ColorLabels"
import HitterFilters from "./HitterFilters"
import HeaderTooltip from "./HeaderTooltip"
import "../styles/hitterRatingsTable.css"

function HitterRatingsTable({
  sortedHitters,
  dataTimeframe,
  searchTerm,
  onSearchChange,
  navigateToHitterPage,
  isActiveSub,
  sortState,
  setSortState,
  setSortDirection,
  filters,
  setFilters,
  availableTeams,
  activeFilterCount,
}) {
  const { state } = useContext(UserContext)

  function handleSort(e) {
    setSortState(e.target.dataset.sortKey)
    setSortDirection((prev) => !prev)
  }

  const hitterColSpan = isActiveSub ? "19" : "14"

  return (
    <div>
      <div className="ratings-container">
        <div className="searchBar">
          <label>Search A Hitter: </label>
          <input
            type="text"
            placeholder="Ex: Kris Bryant"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>

        <HitterFilters
          filters={filters}
          setFilters={setFilters}
          teams={availableTeams}
          activeCount={activeFilterCount}
        />
        <ColorLabels />
        <div className="table-container">
          <table className={`hitterRatingsTable ${isActiveSub ? "sub-active" : "sub-inactive"}`}>
            <thead>
              <tr className="parentHeaders">
                <th colSpan="3" className="hitterInfoGroup">Hitter Info</th>
                <th colSpan={hitterColSpan} className="hitterStatsGroup">Hitter Profile & Matchup Stats</th>
                <th colSpan="14" className="pitcherGroup">Pitcher Info & Stats</th>
              </tr>
              <tr>
                <th className={sortState === "hitter_name" ? "sorted-column" : ""} data-sort-key="hitter_name" onClick={handleSort}><HeaderTooltip label="Name" /><span>↕️</span></th>
                <th className={sortState === "hitter_team" ? "sorted-column" : ""} data-sort-key="hitter_team" onClick={handleSort}><HeaderTooltip label="Team" /><span>↕️</span></th>
                <th className={sortState === "bat_hand" ? "sorted-column" : ""} data-sort-key="bat_hand" onClick={handleSort}><HeaderTooltip label="Bat Hand" /><span>↕️</span></th>
                <th className={sortState === "hit_matchup_rating" ? "sorted-column" : ""} data-sort-key="hit_matchup_rating" onClick={handleSort}><HeaderTooltip label="Matchup Rating" tooltipKey="Hitter Matchup Rating" /><span>↕️</span></th>
                <th className={sortState === "pitch_overall_arsenal_pct" ? "sorted-column" : ""} data-sort-key="pitch_overall_arsenal_pct" onClick={handleSort}><HeaderTooltip label="Arsenal Coverage" /><span>↕️</span></th>
                <th className={sortState === "hit_pa" ? "sorted-column" : ""} data-sort-key="hit_pa" onClick={handleSort}><HeaderTooltip label="PA" /><span>↕️</span></th>
                <th className={sortState === "hit_wrc_plus" ? "sorted-column" : ""} data-sort-key="hit_wrc_plus" onClick={handleSort}><HeaderTooltip label="WRC+" /><span>↕️</span></th>
                <th className={sortState === "hit_woba" ? "sorted-column" : ""} data-sort-key="hit_woba" onClick={handleSort}><HeaderTooltip label="wOBA" /><span>↕️</span></th>
                <th className={sortState === "hit_matchup_woba" ? "sorted-column" : ""} data-sort-key="hit_matchup_woba" onClick={handleSort}><HeaderTooltip label="Matchup wOBA" /><span>↕️</span></th>
                {isActiveSub && (<th className={sortState === "hit_woba_percent_change" ? "sorted-column" : ""} data-sort-key="hit_woba_percent_change" onClick={handleSort}><HeaderTooltip label="wOBA Pct Change" /><span>↕️</span></th>)}
                <th className={sortState === "hit_iso" ? "sorted-column" : ""} data-sort-key="hit_iso" onClick={handleSort}><HeaderTooltip label="ISO" /><span>↕️</span></th>
                <th className={sortState === "hit_matchup_iso" ? "sorted-column" : ""} data-sort-key="hit_matchup_iso" onClick={handleSort}><HeaderTooltip label="Matchup ISO" /><span>↕️</span></th>
                {isActiveSub && (<th className={sortState === "hit_iso_percent_change" ? "sorted-column" : ""} data-sort-key="hit_iso_percent_change" onClick={handleSort}><HeaderTooltip label="ISO Pct Change" /><span>↕️</span></th>)}
                <th className={sortState === "hit_hard_contact_pct" ? "sorted-column" : ""} data-sort-key="hit_hard_contact_pct" onClick={handleSort}><HeaderTooltip label="Hard Contact" /><span>↕️</span></th>
                <th className={sortState === "hit_matchup_hard_contact" ? "sorted-column" : ""} data-sort-key="hit_matchup_hard_contact" onClick={handleSort}><HeaderTooltip label="Matchup Hard Contact" /><span>↕️</span></th>
                {isActiveSub && (<th className={sortState === "hit_hard_contact_percent_change" ? "sorted-column" : ""} data-sort-key="hit_hard_contact_percent_change" onClick={handleSort}><HeaderTooltip label="Hard Contact Pct Change" /><span>↕️</span></th>)}
                <th className={sortState === "hit_hr_per_fb" ? "sorted-column" : ""} data-sort-key="hit_hr_per_fb" onClick={handleSort}><HeaderTooltip label="HR/FB" /><span>↕️</span></th>
                <th className={sortState === "hit_matchup_hr_per_fb" ? "sorted-column" : ""} data-sort-key="hit_matchup_hr_per_fb" onClick={handleSort}><HeaderTooltip label="Matchup HR/FB" /><span>↕️</span></th>
                {isActiveSub && (<th className={sortState === "hit_hr_per_fb_percent_change" ? "sorted-column" : ""} data-sort-key="hit_hr_per_fb_percent_change" onClick={handleSort}><HeaderTooltip label="HR/FB Pct Change" /><span>↕️</span></th>)}
                <th className={sortState === "hit_fb_pct" ? "sorted-column" : ""} data-sort-key="hit_fb_pct" onClick={handleSort}><HeaderTooltip label="FB Pct" /><span>↕️</span></th>
                <th className={sortState === "hit_matchup_fb_pct" ? "sorted-column" : ""} data-sort-key="hit_matchup_fb_pct" onClick={handleSort}><HeaderTooltip label="Matchup FB Rate" /><span>↕️</span></th>
                {isActiveSub && (<th className={sortState === "hit_fb_percent_change" ? "sorted-column" : ""} data-sort-key="hit_fb_percent_change" onClick={handleSort}><HeaderTooltip label="FB Pct Change" /><span>↕️</span></th>)}
                <th className={sortState === "pitcher_name" ? "sorted-column" : ""} data-sort-key="pitcher_name" onClick={handleSort}><HeaderTooltip label="Name" /><span>↕️</span></th>
                <th className={sortState === "pitcher_team" ? "sorted-column" : ""} data-sort-key="pitcher_team" onClick={handleSort}><HeaderTooltip label="Team" /><span>↕️</span></th>
                <th className={sortState === "throw_hand" ? "sorted-column" : ""} data-sort-key="throw_hand" onClick={handleSort}><HeaderTooltip label="Throw Hand" /><span>↕️</span></th>
                <th className={sortState === "sp_ip" ? "sorted-column" : ""} data-sort-key="sp_ip" onClick={handleSort}><HeaderTooltip label="IP" /><span>↕️</span></th>
                <th className={sortState === "sp_woba" ? "sorted-column" : ""} data-sort-key="sp_woba" onClick={handleSort}><HeaderTooltip label="wOBA" /><span>↕️</span></th>
                <th className={sortState === "sp_iso" ? "sorted-column" : ""} data-sort-key="sp_iso" onClick={handleSort}><HeaderTooltip label="ISO" /><span>↕️</span></th>
                <th className={sortState === "sp_hard_contact" ? "sorted-column" : ""} data-sort-key="sp_hard_contact" onClick={handleSort}><HeaderTooltip label="Hard Contact Rate" /><span>↕️</span></th>
                <th className={sortState === "sp_soft_contact" ? "sorted-column" : ""} data-sort-key="sp_soft_contact" onClick={handleSort}><HeaderTooltip label="Soft Contact Rate" /><span>↕️</span></th>
                <th className={sortState === "sp_kpct" ? "sorted-column" : ""} data-sort-key="sp_kpct" onClick={handleSort}><HeaderTooltip label="K Rate" /><span>↕️</span></th>
                <th className={sortState === "sp_bbpct" ? "sorted-column" : ""} data-sort-key="sp_bbpct" onClick={handleSort}><HeaderTooltip label="Walk Rate" /><span>↕️</span></th>
                <th className={sortState === "sp_xfip" ? "sorted-column" : ""} data-sort-key="sp_xfip" onClick={handleSort}><HeaderTooltip label="xFIP" /><span>↕️</span></th>
                <th className={sortState === "sp_fbpct" ? "sorted-column" : ""} data-sort-key="sp_fbpct" onClick={handleSort}><HeaderTooltip label="FB Rate" /><span>↕️</span></th>
                <th className={sortState === "sp_gbpct" ? "sorted-column" : ""} data-sort-key="sp_gbpct" onClick={handleSort}><HeaderTooltip label="GB Rate" /><span>↕️</span></th>
                <th className={sortState === "sp_hr_per_fb" ? "sorted-column" : ""} data-sort-key="sp_hr_per_fb" onClick={handleSort}><HeaderTooltip label="HR/FB" /><span>↕️</span></th>
              </tr>
            </thead>
            <tbody>
              {sortedHitters?.map((stat) => {
                const teamStyles = { backgroundColor: state.teamColors[stat.hitter_team].primary || "transparent" }
                const matchupRatingStyles = {
                  backgroundColor: (stat.hit_matchup_rating >= 0.450 ? "lightblue" : "") || (stat.hit_matchup_rating >= 0.400 && stat.hit_matchup_rating < 0.450 ? "lightgreen" : "") || (stat.hit_matchup_rating > 0.333 && stat.hit_matchup_rating < 0.400 ? "lightyellow" : "") || (stat.hit_matchup_rating <= 0.230 ? "lightpink" : ""),
                }
                const matchupWOBAStyles = {
                  backgroundColor: (stat.hit_matchup_woba >= 0.400 ? "lightblue" : "") || (stat.hit_matchup_woba < 0.400 && stat.hit_matchup_woba > 0.350 ? "lightgreen" : "") || (stat.hit_matchup_woba >= 0.315 && stat.hit_matchup_woba < 0.350 ? "lightyellow" : "") || (stat.hit_matchup_woba <= 0.300 ? "lightpink" : ""),
                }
                const matchupISOStyles = {
                  backgroundColor: (stat.hit_matchup_iso >= 0.275 ? "lightblue" : "") || (stat.hit_matchup_iso < 0.275 && stat.hit_matchup_iso >= 0.200 ? "lightgreen" : "") || (stat.hit_matchup_iso > 0.160 && stat.hit_matchup_iso < 0.199 ? "lightyellow" : "") || (stat.hit_matchup_iso <= 0.150 ? "lightpink" : ""),
                }
                const matchupHCStyles = {
                  backgroundColor: (stat.hit_matchup_hard_contact >= 50.0 ? "lightblue" : "") || (stat.hit_matchup_hard_contact < 50.0 && stat.hit_matchup_hard_contact >= 40.0 ? "lightgreen" : "") || (stat.hit_matchup_hard_contact >= 35.0 && stat.hit_matchup_hard_contact < 40.0 ? "lightyellow" : "") || (stat.hit_matchup_hard_contact <= 29.0 ? "lightpink" : ""),
                }
                const matchupFBStyles = {
                  backgroundColor: (stat.hit_matchup_fb_pct >= 50.0 ? "lightblue" : "") || (stat.hit_matchup_fb_pct < 50.0 && stat.hit_matchup_fb_pct >= 40.0 ? "lightgreen" : "") || (stat.hit_matchup_fb_pct > 38.0 && stat.hit_matchup_fb_pct < 40.0 ? "lightyellow" : "") || (stat.hit_matchup_fb_pct <= 30.0 ? "lightpink" : ""),
                }
                const wOBApercentChangeStyles  = { color: stat.hit_woba_percent_change > 0 ? "rgba(0,100,0)" : "rgba(139,0,0)" }
                const ISOpercentChangeStyles   = { color: stat.hit_iso_percent_change > 0 ? "rgba(0,100,0)" : "rgba(139,0,0)" }
                const HCpercentChangeStyles    = { color: stat.hit_hard_contact_percent_change > 0 ? "rgba(0,100,0)" : "rgba(139,0,0)" }
                const HRFBpercentChangeStyles  = { color: stat.hit_hr_per_fb_percent_change > 0 ? "rgba(0,100,0)" : "rgba(139,0,0)" }
                const FBpercentChangeStyles    = { color: stat.hit_fb_percent_change > 0 ? "rgba(0,100,0)" : "rgba(139,0,0)" }

                // Arsenal coverage — fields come directly from the backend JOIN
                const arsenalCell = (() => {
                  const stars = stat.pitch_overall_stars
                  const pct   = stat.pitch_overall_arsenal_pct

                  if (stars == null && pct == null) {
                    return <td className="arsenal-coverage-cell arsenal-no-report">—</td>
                  }
                  return (
                    <td className="arsenal-coverage-cell">
                      <span className="arsenal-stars">
                        {Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < (stars ?? 0) ? "star filled" : "star empty"}>★</span>
                        ))}
                      </span>
                      {stat.pitch_overall_low_data ? (
                        <span
                          className="arsenal-no-pitch-data"
                          title={`Only ${stat.pitch_overall_data_coverage_pct?.toFixed(0)}% of arsenal has enough PA`}
                        >
                          No Pitch Data
                        </span>
                      ) : (
                        <span className="arsenal-pct-label">
                          {pct != null ? `${Number(pct).toFixed(1)}%` : "—"}
                        </span>
                      )}
                    </td>
                  )
                })()

                return (
                  <tr key={stat.id}>
                    <td id="hitterNameTD" onClick={() => navigateToHitterPage(stat?.hitter_name, stat?.hitter_id)}>{stat?.hitter_name}</td>
                    <td style={teamStyles}>{stat?.hitter_team}</td>
                    <td>{stat?.bat_hand}</td>
                    <td style={matchupRatingStyles}>{stat?.hit_matchup_rating?.toFixed(3)}</td>
                    {arsenalCell}
                    <td>{stat?.hit_pa}</td>
                    <td>{stat?.hit_wrc_plus}</td>
                    <td>{stat?.hit_woba}</td>
                    <td style={matchupWOBAStyles}>{stat?.hit_matchup_woba?.toFixed(3)}</td>
                    {isActiveSub && (<td style={wOBApercentChangeStyles}>{stat?.hit_woba_percent_change?.toFixed(1)}%</td>)}
                    <td>{stat?.hit_iso}</td>
                    <td style={matchupISOStyles}>{stat?.hit_matchup_iso?.toFixed(3)}</td>
                    {isActiveSub && (<td style={ISOpercentChangeStyles}>{stat?.hit_iso_percent_change?.toFixed(1)}%</td>)}
                    <td>{stat?.hit_hard_contact_pct}%</td>
                    <td style={matchupHCStyles}>{stat?.hit_matchup_hard_contact?.toFixed(1)}%</td>
                    {isActiveSub && (<td style={HCpercentChangeStyles}>{stat?.hit_hard_contact_percent_change?.toFixed(1)}%</td>)}
                    <td>{stat?.hit_hr_per_fb}%</td>
                    <td>{stat?.hit_matchup_hr_per_fb?.toFixed(1)}%</td>
                    {isActiveSub && (<td style={HRFBpercentChangeStyles}>{stat?.hit_hr_per_fb_percent_change?.toFixed(1)}%</td>)}
                    <td>{stat?.hit_fb_pct}%</td>
                    <td style={matchupFBStyles}>{stat?.hit_matchup_fb_pct?.toFixed(1)}%</td>
                    {isActiveSub && (<td style={FBpercentChangeStyles}>{stat?.hit_fb_percent_change?.toFixed(1)}%</td>)}
                    <td>{stat?.pitcher_name}</td>
                    <td>{stat?.pitcher_team}</td>
                    <td>{stat?.throw_hand}</td>
                    <td>{stat?.sp_ip}</td>
                    <td>{stat?.sp_woba}</td>
                    <td>{stat?.sp_iso}</td>
                    <td>{stat?.sp_hard_contact.toFixed(1)}%</td>
                    <td>{stat?.sp_soft_contact.toFixed(1)}%</td>
                    <td>{stat?.sp_kpct.toFixed(1)}%</td>
                    <td>{stat?.sp_bbpct.toFixed(1)}%</td>
                    <td>{stat?.sp_xfip}</td>
                    <td>{stat?.sp_fbpct.toFixed(1)}%</td>
                    <td>{stat?.sp_gbpct.toFixed(1)}%</td>
                    <td>{stat?.sp_hr_per_fb.toFixed(1)}%</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default HitterRatingsTable